import MarkdownParser from 'components/rich-text/markdown-parser';
import RichText from 'components/rich-text';
import { ScrollableContainer } from '../scrollable-container';
import styles from './about-panel.module.scss';
import type { PortableTextBlock } from '@portabletext/types';

export default function AboutPanel({ about, howToCite }: AboutPanelProps) {
	return (
		<ScrollableContainer>
			<div className={styles.container}>
				<RichText value={about} />
				<p>
					<span className={styles.howToCiteLabel}>Cite this object:</span>{' '}
					<MarkdownParser>{howToCite}</MarkdownParser>
				</p>
			</div>
		</ScrollableContainer>
	);
}

interface AboutPanelProps {
	about: PortableTextBlock[];
	howToCite: string;
}
